import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../AuthContext"; // Import AuthContext
import "../assets/CSS/Sidebar.css"; // Add custom styles here if needed
import logo from "../assets/Img/Logo-1.png";
import axiosInstance from "../axiosConfig";

const Sidebar = () => {
  const { user } = useContext(AuthContext); // Get the user's role from AuthContext
  const [ticketCount, setTicketCount] = useState(0); // State to store ticket count
  const [score, setScore] = useState(null); // State for performance score //// 17 Jan 25 Yogesh
  const [performance, setPerformance] = useState(null); // State for performance percentage //// 17 Jan 25 Yogesh
  const [RMCount, setRMCount] = useState(0); // State for inventory count
  const [NokeData, setNokeData] = useState(0); // State for
  const [LoopiCheckingCount, setLoopiCheckingCount] = useState(0); // State for Loopi Checking Count
  const [SalesFlowCount, setSalesFlowCount] = useState(0); // State for Sales Flow Count
  // const [scanCount, setScanCount] = useState(0); // State for Sales Flow Count
  const [dispatch, setDispatchCount] = useState(0); // State for order count
  const [dispatchConfirm, setConfirmCount] = useState(0); // State for order count
  const [Delay30minCount, set30minDelayCount] = useState(0); // State for
  const [Delay60minCount, set60minDelayCount] = useState(0);
  const [Delay90minCount, set90minDelayCount] = useState(0);
  // Compute whether “now” in IST is between 15:00 and 19:00
  const [canAddInv, setCanAddInv] = useState(false);

  // state for Rm Upload module
  const [canRMUpload, setCanRMUpload] = useState(false);
  // state for Excel Import module
  const [canCSVimport, setCanCSVimport] = useState(false);
  // state for Sales Flow INV module
  const [canSalesInvoice, setSalesInvoice] = useState(false);
  // state for Sales Flow SRP module
  const [canSalesSRP, setSalesSRP] = useState(false);

  // RM Return Notification's
  const [CaptureNotify, setCaptureNotify] = useState(0);
  const [Approve, setApprove] = useState(0);
  // state for RM issue count
  const [rmIssueCount, setRMIssueCount] = useState(0);

  //Red Process count
  const [Approval, setApprovalCount] = useState(0);

  
  const [remarks, setRemarksCount] = useState(0);
  
  // const [RedProcessData, setRedProcessData] = useState([]);
  const [RedProcessCount, setRedProcessCount] = useState(0);

  const [CheckpointsCount, setCheckpointsCount] = useState(0);
  


  // const [remarks, setRemarksCount] = useState(0);

  // const [RedProcessData, setRedProcessData] = useState([]);
  // const [RedProcessCount, setRedProcessCount] = useState(0);


  useEffect(() => {
    // Fetch the ticket count when the component mounts
    const fetchTicketCount = async () => {
      try {
        const response = await axiosInstance.get("/api/ticketsAdmin"); // Use appropriate API for admin tickets
        setTicketCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    //new code 17 Jan 25 Yogesh
    // Fetch performance data for the logged-in supervisor
    const fetchPerformanceData = async () => {
      try {
        const response = await axiosInstance.get("/api/performance"); // API call for performance
        const data = response.data;

        // Filter performance data for the logged-in supervisor
        const supervisorData = data.find(
          (item) => item.SupervisorName === user?.Name
        );

        // Update state with score and performance
        if (supervisorData) {
          setScore(supervisorData.Score);
          setPerformance(supervisorData.Performance);
        }
      } catch (error) {
        console.error("Error fetching performance data:", error);
      }
    };
    ///new code end 28 Jan 25
    // Fetch inventory count for the logged-in supervisor
    const fetchInventoryCount = async () => {
      try {
        const response = await axiosInstance.get("/api/noke-inventory"); // API to fetch inventory
        const filteredInventory = response.data.filter(
          (item) => item["SUPERVISOR"] === user?.Name
        ); // Filter by logged-in supervisor's name
        setRMCount(filteredInventory.length); // Set the count of inventory records
      } catch (error) {
        console.error("Error fetching inventory count:", error);
      }
    };

    // Fetch the ticket count when the component mounts
    const fetchNokeCount = async () => {
      try {
        const response = await axiosInstance.get("/api/noke-data"); // Use appropriate API for admin tickets
        setNokeData(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    // Fetch Loopi Checking Count for the logged-in supervisor// 12 Feb 25
    const fetchLoopiCheckingCount = async () => {
      try {
        const response = await axiosInstance.get("/api/loopi-checking"); // API to fetch Loopi Checking
        const filteredLoopiChecking = response.data.filter(
          (item) => item["Current_Supervisor"] === user?.Name
        ); // Filter by logged-in supervisor's name
        setLoopiCheckingCount(filteredLoopiChecking.length); // Set the count of  records
        // console.log("LoopiCheckingCount", filteredLoopiChecking.length);
      } catch (error) {
        console.error("Error fetching LoopiChecking count:", error);
      }
    };
    // const canViewApproval =
    //   user?.Auth === "Admin" ||
    //   user?.Auth === "Supervisor" ||
    //   (user?.Auth === "SuperAdmin" &&
    //     !["33", "34", "35", "36", "10"].includes(user?.EmployeeID));

    // Fetch Sales Flow Count for the admin// 14 Feb 25
    const fetchSalesFlowCount = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/sales-flow-Notification"
        ); // Use appropriate API for admin tickets
        setSalesFlowCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    //
    const fetchDispatchCount = async () => {
      try {
        const response = await axiosInstance.get("/api/sales-flow-Dispatch"); // Use appropriate API for admin tickets
        setDispatchCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    const fetchDispatchConfirmCount = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/confirm-Dispatch-Notify"
        ); // Use appropriate API for admin tickets
        setConfirmCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    //notification for supervisor 30min delay tickets
    const fetch30min_DelayCount = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/tickets/byRole/Supervisor?supervisorId=${user.EmployeeID}`
        ); // Use appropriate API for admin tickets
        set30minDelayCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    //notification for Admin 1hour delay tickets
    const fetch60min_DelayCount = async () => {
      try {
        const response = await axiosInstance.get(`/api/tickets/byRole/Admin`); // Use appropriate API for admin tickets
        set60minDelayCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    //notification for SuperAdmin 1.5hour delay tickets
    const fetch90min_DelayCount = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/tickets/byRole/SuperAdmin`
        ); // Use appropriate API for admin tickets
        set90minDelayCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    /// RM Return Capture
    const fetchReturnCapture = async () => {
      try {
        const response = await axiosInstance.get(`/api/return-Capture-Notify`); // Use appropriate API for admin tickets
        setCaptureNotify(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };
    /// RM Return Approve
    const fetchReturnApprove = async () => {
      try {
        const response = await axiosInstance.get(`/api/return-Approve-Notify`); // Use appropriate API for admin tickets
        setApprove(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    // simple fetch function
    const fetchRMIssueCount = async () => {
      try {
        // Derive the exact USER NAME from your AuthContext / localStorage
        const user = JSON.parse(localStorage.getItem("userData") || "{}");
        const rawName = user.Name || "";
        const currentUser =
          rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase();

        // Call the notifications API with userName param
        const { data } = await axiosInstance.get("/api/rm-notifications", {
          params: { userName: currentUser },
        });

        // The API returns { count: <number> }
        setRMIssueCount(data.count);
      } catch (err) {
        console.error("❌ Error fetching RM issue count:", err);
      }
    };

    const fetchRemarksApproval = async () => {
      try {
        const response = await axiosInstance.get(`/api/remarks-Notify`); // Use appropriate API for admin tickets
        setApprovalCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    const fetchRemarks = async () => {
      try {
        const response = await axiosInstance.get(`/api/remarks`); // Use appropriate API for admin tickets
        setRemarksCount(response.data.length); // Set the count based on the number of tickets
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };

    const fetchRedProcess = async () => {
      try {
        const response = await axiosInstance.get("api/get-RedProcess");
        const allData = response.data || [];

        if (user?.Auth === "Supervisor") {
          const filtered = allData.filter((item) =>
            item.Supervisor?.toLowerCase().includes(user.Name.toLowerCase())
          );
          // setRedProcessData(filtered);
          setRedProcessCount(filtered.length); // ✅ set count properly
        } else {
          // setRedProcessData(allData);
          setRedProcessCount(allData.length); // ✅ for Admin / SuperAdmin
        }
      } catch (error) {
        console.error("Error fetching Red Process data:", error);
      }
    };

    const fetchCheckPointsData = async () => {
  try {
    const { data } = await axiosInstance.get(`/api/get-CheckPoint-FormData`);
    setCheckpointsCount(Array.isArray(data) ? data.length : 0);
  } catch (error) {
    if (error.response?.status === 404) {
      setCheckpointsCount(0); // treat 404 as "no items"
    } else {
      // optionally surface/log the real error
      // console.error(error);
    }
  }
};

    // Fetch  count for superadmin
    if (user?.Auth === "SuperAdmin") {
      fetchTicketCount();
      fetchDispatchConfirmCount();
      fetch90min_DelayCount();
      fetchRemarksApproval();
      fetchRedProcess();
    }
    // Fetch  count for admin
    if (user?.Auth === "Admin") {
      fetchSalesFlowCount();
      fetch60min_DelayCount();
      fetchReturnApprove();
      fetchTicketCount();
      fetchRMIssueCount();
      fetchRemarks();
      fetchRedProcess();
      fetchCheckPointsData();
    }
    // Fetch  count for supervisor
    //performace data
    if (user?.Auth === "Supervisor") {
      fetchPerformanceData();
      fetchInventoryCount();
      fetchNokeCount();
      fetchLoopiCheckingCount();
      fetchDispatchCount(); // Notification for sudhir 25 fab 25
      fetchSalesFlowCount();
      fetch30min_DelayCount();
      fetchReturnCapture();
      fetchRMIssueCount();
      fetchRedProcess();
    }
  }, [user]);

  // check every minute whether IST is between 15:00 and 19:00
  useEffect(() => {
    const checkWindow = () => {
      // Grab current time in IST
      const nowIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );
      const hour = nowIST.getHours();
      // Allow between 15:00 (3 PM) inclusive and 19:00 (7 PM) exclusive
      setCanAddInv(hour >= 15 && hour < 19);
    };

    checkWindow();
    const timer = setInterval(checkWindow, 60_000); // re-check every minute
    return () => clearInterval(timer);
  }, []);

  // effect that runs once + every minute: for RM Upload module
  useEffect(() => {
    const checkRMWindow = () => {
      const nowIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );
      const hour = nowIST.getHours();
      // true if hour >= 15 (3 PM) OR hour < 10 (10 AM) → wraps past midnight
      setCanRMUpload(hour >= 15 || hour < 10);
    };

    checkRMWindow();
    const timer2 = setInterval(checkRMWindow, 60_000);
    return () => clearInterval(timer2);
  }, []);

  // effect that runs once + every minute: for Excel Import module
  useEffect(() => {
    const checkRMWindow = () => {
      const nowIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );
      const hour = nowIST.getHours();
        // ✅ Allow between 15:00 (3 PM) inclusive and 19:00 (7 PM) exclusive
      setCanCSVimport(hour >= 13 && hour < 19);
    };

    checkRMWindow();
    const timer2 = setInterval(checkRMWindow, 60_000);
    return () => clearInterval(timer2);
  }, []);

  // effect that runs once + every minute: for Excel Import module
  useEffect(() => {
    const checkRMWindow = () => {
      const nowIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );
      const hour = nowIST.getHours();
      // Allow between 10:00 (10 AM) inclusive and 15:00 (3 PM) exclusive
      setSalesInvoice(hour >= 10 && hour < 15);
    };

    checkRMWindow();
    const timer2 = setInterval(checkRMWindow, 60_000);
    return () => clearInterval(timer2);
  }, []);

  // effect that runs once + every minute: for Sales Flow srp module
  useEffect(() => {
    const checkRMWindow = () => {
      const nowIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );
      const hour = nowIST.getHours();
      // true if hour >= 15 (3 PM) OR hour < 10 (10 AM) → wraps past midnight
      setSalesSRP(hour >= 15 || hour < 10);
    };

    checkRMWindow();
    const timer2 = setInterval(checkRMWindow, 60_000);
    return () => clearInterval(timer2);
  }, []);

  //   useEffect(() => {
  //   const checkWindow = () => {
  //     // Get “now” in IST
  //     const nowIST = new Date(
  //       new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  //     );
  //     const totalMinutes = nowIST.getHours() * 60 + nowIST.getMinutes();

  //     // 11:55 AM is 11*60+55 = 715; 12:00 PM is 12*60 = 720
  //     setCanAddInv(totalMinutes >= 715 && totalMinutes < 720);
  //   };

  //   checkWindow();
  //   const timerId = setInterval(checkWindow, 15_000); // re-check every 15 seconds
  //   return () => clearInterval(timerId);
  // }, []);

  // const handleAddInvClick = (e) => {
  //   if (!canAddInv) {
  //     e.preventDefault();
  //     // you can replace this with your showAlert(...)
  //     window.alert("Add Inventory is only accessible between 3 PM To 7 PM .");
  //   }
  // };

  return (
    <div className="d-flex flex-column vh-100 bg-light sidebar ">
      <div className=" text-center">
        <a className="navbar-brand">
          <img
            src={logo}
            className="mt-2"
            alt="Fibre Bond Logo"
            style={{ height: "40px", width: "auto", marginLeft: "-35px" }}
          />
        </a>
      </div>
      {/* 👇 SCROLLABLE CONTENT STARTS HERE */}
      <div className="sidebar-scrollable">
        <ul className="nav flex-column NavlinkCss">
          <li className="nav-item">
            <NavLink
              to="/Main-dashboard"
              // className="nav-link"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              // activeClassName="active"
            >
              <i className="bi bi-bar-chart-line me-2"></i> Dashboard
            </NavLink>
          </li>

          {/* Hiding Worker Attendance until production rollout
          {(isAdmin || isSupervisor) && (
            <li className="nav-item">
              <NavLink
                to="/attendance"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-clock-history me-2"></i> Worker Attendance
              </NavLink>
            </li>
          )}
          */}

          {/* (user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/wip-photo-logs"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-camera me-2"></i> WIP Photo Logs
              </NavLink>
            </li>
          ) */}

          {(user?.Auth === "Admin" ||
            user?.Auth === "Supervisor" ||
            // (user?.Auth === "SuperAdmin" && user?.EmployeeID !== "33")) && (
            (user?.Auth === "SuperAdmin" &&
              !["33", "34", "35", "36", "10"].includes(user?.EmployeeID))) && (
            <li className="nav-item">
              <NavLink
                to="/users"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi  bi-people-fill me-2"></i> Users
              </NavLink>
            </li>
          )}
          {/* {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && ( */}
          {(user?.Auth === "Admin" ||
            user?.Auth === "Supervisor" ||
            (user?.Auth === "SuperAdmin" &&
              !["33", "34", "35", "36", "10"].includes(user?.EmployeeID))) && (
            <li className="nav-item">
              <NavLink
                to="/department"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-diagram-3 me-2"></i> Department
              </NavLink>
            </li>
          )}
          {/* {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && ( */}
          {(user?.Auth === "Admin" ||
            user?.Auth === "Supervisor" ||
            (user?.Auth === "SuperAdmin" &&
              !["33", "34", "35", "36", "10"].includes(user?.EmployeeID))) && (
            <li className="nav-item">
              <NavLink
                to="/workers"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-person-workspace me-2"></i> Workers
              </NavLink>
            </li>
          )}
          
          {/* Handover & Remediation Queue */}
          
          {/*<li className="nav-item">
            <NavLink
              to="/wip-handover-scanner"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-upc-scan me-2"></i> Handover Scanner
            </NavLink>
          </li>
          
          <li className="nav-item">
            <NavLink
              to="/wip-qc-scanner"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-shield-check me-2"></i> QC Scanner
            </NavLink>
          </li>
          */}
          
          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin" || user?.Auth === "Admin_wip" || user?.Auth === "Supervisor") && (
            <li className="nav-item">
              <NavLink
                to="/manager-remediation"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-shield-lock-fill me-2 text-danger"></i> Manager Console
              </NavLink>
            </li>
          )}

          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin" || user?.Auth === "Admin_wip" || user?.Auth === "Supervisor") && (
            <li className="nav-item">
              <NavLink
                to="/production-report"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-bar-chart-line-fill me-2 text-success"></i> Daily Production Report
              </NavLink>
            </li>
          )}
          
          <li className="nav-item">
            <NavLink
              to="/approval-forms"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-textarea-resize me-2"></i> Form Links
            </NavLink>
          </li>
          {/* Ticketing Link - Only Visible to SuperAdmin */}
          {(
            user?.Auth === "SuperAdmin" ||
            (user?.Auth === "Supervisor" && user?.EmployeeID === "1022")
          ) && (
            <li className="nav-item">
              <NavLink
                to="/ticket-admin"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-ticket-detailed me-2"></i> Ticketing{" "}
                {ticketCount > 0 && (
                  <span className="badge bg-danger">{ticketCount}</span>
                )}
              </NavLink>
            </li>
          )}

          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin" || user?.Auth === "Owner") && (
            <li className="nav-item">
              <NavLink
                to="/worker-rating-history"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-person-lines-fill me-2"></i> Worker Ratings
              </NavLink>
            </li>
          )}
          
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/ticket-home"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-journal-plus me-2"></i> Raise Ticket{" "}
                {ticketCount > 0 && (
                  <span className="badge bg-danger">{ticketCount}</span>
                )}
              </NavLink>
            </li>
          )}

          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/remarks"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-journal-text me-2"></i> Remarks{" "}
                {remarks > 0 && (
                  <span className="badge bg-danger">{remarks}</span>
                )}
              </NavLink>
            </li>
          )}

          <li className="nav-item">
            <NavLink
              to="/sheet-quantity-leather"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-palette me-2"></i> Sheet Qty Leather (pdf)
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/sheet-quantity-leather-excel"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-palette me-2"></i> Sheet Qty Leather (excel)
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/leather-automation"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-palette me-2"></i> Leather Automation
            </NavLink>
          </li>

          {(
            user?.Auth === "Admin" ||
            user?.Auth === "SuperAdmin" ||
            user?.Auth === "Supervisor"
          ) && (
            <li className="nav-item">
              <NavLink
                to="/box-party-wise"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-palette me-2"></i> Box Party Wise
              </NavLink>
            </li>
          )}

          {(
            user?.Auth === "Admin" ||
            user?.Auth === "SuperAdmin" 
          ) && (
            <li className="nav-item">
              <NavLink
                to="/die-purchase-summary"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-bar-chart-line me-2"></i> Die Purchase Summary
              </NavLink>
            </li>
          )}

          {(
            user?.Auth === "Admin" ||
            user?.Auth === "SuperAdmin" 
          ) && (
            <>
              <li className="nav-item">
                <NavLink 
                  to="/purchase-dashboard" 
                  className={({ isActive }) => isActive ? "nav-link active d-flex align-items-center" : "nav-link d-flex align-items-center"}
                >
                  <i className="bi bi-receipt me-2"></i> 
                  Purchase Invoices
                  <span className="badge bg-primary rounded-pill ms-2" style={{ fontSize: '0.7rem' }}>AI</span>
                </NavLink>
              </li>

            </>
          )}


          {/* && !["33", "34", "35", "36"].includes(user?.EmployeeID)) && */}
          {/* Ṇew Module create on 13 fab 25 this will only visible to Ashwini */}
          {/* {user?.Auth === "Admin" &&
            ["1017", "1021", "1022"].includes(user?.EmployeeID) && ( */}
          {/* this module for developement purpose only--- yogesh */}

          {["1021","1022","9696"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/sales-flow"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-graph-up-arrow me-2"></i> Sales Flow
                </NavLink>
              </li>
            )}

            {["1021","1022","4001","9696"].includes(user?.EmployeeID) && (

              <li className="nav-item">
                <NavLink
                  to="/salary-finalization"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-graph-up-arrow me-2"></i> Salary Finalization
                </NavLink>
              </li>
            )}

               {/* {user?.Auth === "Admin" &&
            ["1017"].includes(user?.EmployeeID) && ( */}

          {/* {["1021"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/sales-flow"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-graph-up-arrow me-2"></i> Sales Flow
              </NavLink>
            </li>
          )} */}

          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") &&
            ["1017", "1022", "9696"].includes(user?.EmployeeID) && (

              <li className="nav-item">
                <NavLink
                  to="/sales-flow"
                  end
                  className={({ isActive }) =>
                    // only highlight as active if we're on the page AND it's within 3–7pm
                    isActive && canSalesSRP ? "nav-link active" : "nav-link"
                  }
                  style={{
                    cursor: "pointer",
                    opacity: canSalesSRP ? 1 : 0.7, // just visually fade it when off-hours
                  }}
                  onClick={(e) => {
                    if (!canSalesSRP) {
                      e.preventDefault();
                      window.alert(
                        "Sales Flow is only accessible between 3 PM To 10 AM."
                      );
                    }
                  }}
                >
                  <i className="bi bi-graph-up-arrow me-2"></i> Sales Flow
                </NavLink>
              </li>
            )}
        {/* new module Created on 17 July 25 */}
         {["1021","1017","9696"].includes(user?.EmployeeID) && (
                <li className="nav-item">
                  <NavLink
                    to="/Sales-Flow-Excelimport"
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    <i className="bi bi-upload me-2"></i> Sales Flow Excel Import
                  </NavLink>
                </li>
              )}

          {/* new module Created on 19 July 25 */}
         {["1021","1015","9696"].includes(user?.EmployeeID) && (
                <li className="nav-item">
                  <NavLink
                    to="/Sales-Flow-Tally"
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    <i className="bi bi-graph-up-arrow me-2"></i> Sales Flow Tally
                  </NavLink>
                </li>
              )}
              
          {/* Ṇew Module create on 13 fab 25 this will only visible to Faizan */}
          {/* {(user?.Auth === "Admin" && user?.EmployeeID === "1019") && (
          <li className="nav-item">
            <NavLink
              to="/sales-scan"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-calendar-check"></i>Sales Flow{" "}
              {scanCount > 0 && (
                <span className="badge bg-danger">{scanCount}</span>
              )}
            </NavLink>
          </li>
        )} */}
          {/* Ṇew Module create on 25 fab 25 this will only visible to Shudhir */}
          {(
            (user?.Auth === "Supervisor" && user?.EmployeeID === "12") ||
            user?.Auth === "SuperAdmin"
          ) && (
            <li className="nav-item">
              <NavLink
                to="/sales-flow-dispatch"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-graph-up-arrow me-2"></i>Sales Flow{" "}
                {dispatch > 0 && (
                  <span className="badge bg-danger">{dispatch}</span>
                )}
              </NavLink>
            </li>
          )}

          {/* Ṇew Module create on 17 March 25 this will only visible to swapnil */}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") &&
            ["ADM01", "11"].includes(user?.EmployeeID) &&
            !["33", "34", "35", "36"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/Dispatch-Confirm"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-graph-up-arrow me-2"></i>Sales Flow{" "}
                  {dispatchConfirm > 0 && (
                    <span className="badge bg-danger">{dispatchConfirm}</span>
                  )}
                </NavLink>
              </li>
            )}

          {/* Ṇew Module create on 22 fab 25 this will only visible to Ashwini */}
          {/* {(user?.Auth === "SuperAdmin" && !["33", "34", "35", "36"].includes(user?.EmployeeID)) && ( */}
          {user?.Auth === "Admin" &&
            ["1017", "1019", "1021", "1022"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/RM-View"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-box-seam me-2"></i> RM View
                </NavLink>
              </li>
            )}
          {/* Ṇew Module create on 13 fab 25 this will only visible to Pranita changes on 05 apr 25*/}
          {/* {user?.Auth === "Admin" &&
            ["1016", "1019","9696"].includes(user?.EmployeeID) && ( */}
          {/* this module for developement purpose only--- yogesh */}
          {["1021"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/sales-flowNotify"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-graph-up-arrow me-2"></i>Sales Flow{" "}
                {SalesFlowCount > 0 && (
                  <span className="badge bg-danger">{SalesFlowCount}</span>
                )}
              </NavLink>
            </li>
          )}

          {user?.Auth === "Admin" &&
            ["1016", "1019", "9696"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/sales-flowNotify"
                  end
                  className={({ isActive }) =>
                    // only highlight as active if we're on the page AND it's within 3–7pm
                    isActive && canSalesInvoice ? "nav-link active" : "nav-link"
                  }
                  style={{
                    cursor: "pointer",
                    opacity: canSalesInvoice ? 1 : 0.7, // just visually fade it when off-hours
                  }}
                  onClick={(e) => {
                    if (!canSalesInvoice) {
                      e.preventDefault();
                      window.alert(
                        "Sales Flow is only accessible between 10 AM To 3 PM."
                      );
                    }
                  }}
                >
                  <i className="bi bi-graph-up-arrow me-2"></i>Sales Flow{" "}
                  {SalesFlowCount > 0 && (
                    <span className="badge bg-danger">{SalesFlowCount}</span>
                  )}
                </NavLink>
              </li>
            )}

          {/* this module for developement purpose only--- yogesh */}
          {["1021", "9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/add-inventory"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-cloud-arrow-down me-2"></i> Add Inventory{" "}
                {NokeData > 0 && (
                  <span className="badge bg-danger">{NokeData}</span>
                )}
              </NavLink>
            </li>
          )}

          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") &&
            (user?.Name === "MONU" || user?.Name === "SIDDHU") && (
              <li className="nav-item">
                <NavLink
                  to="/add-inventory"
                  end
                  className={({ isActive }) =>
                    // only highlight as active if we're on the page AND it's within 3–7pm
                    isActive && canAddInv ? "nav-link active" : "nav-link"
                  }
                  style={{
                    cursor: "pointer",
                    opacity: canAddInv ? 1 : 0.7, // just visually fade it when off-hours
                  }}
                  onClick={(e) => {
                    if (!canAddInv) {
                      e.preventDefault();
                      window.alert(
                        "Add Inventory is only accessible between 3 PM To 7 PM."
                      );
                    }
                  }}
                >
                  <i className="bi bi-cloud-arrow-down me-2" />
                  Add Inventory{" "}
                  {NokeData > 0 && (
                    <span className="badge bg-danger">{NokeData}</span>
                  )}
                </NavLink>
              </li>
            )}

          {/* /////////////////////////// */}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") &&
            user?.Name !== "MONU" &&
            user?.Name !== "SIDDHU" && (
              <li className="nav-item">
                <NavLink
                  to="/view-inventory"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-collection me-2"></i> View Inventory{" "}
                  {RMCount > 0 && (
                    <span className="badge bg-danger">{RMCount}</span>
                  )}
                </NavLink>
              </li>
            )}
          {/* end */}

          {/* New module created 17 Feb 25 for Excel Import  backup code*/}
          {/* {(user?.Auth === "Supervisor" || user?.Auth === "Admin" || user?.Auth === "SuperAdmin") &&
            ["2", "1017", "2918", "1021", "1293", "1016", "1022", "9696"].includes(
              user?.EmployeeID
            ) && (
              <li className="nav-item">
                <NavLink
                  to="/excel-import"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-upload me-2"></i> Excel Import{" "}
                </NavLink>
              </li>
            )} */}
 
          {(user?.Auth === "Supervisor" || user?.Auth === "Admin" || user?.Auth === "SuperAdmin") &&
            ["2", "1017", "2918", "1021", "1293", "1016", "1022", "9696"].includes(
              user?.EmployeeID
            ) && (
              <li className="nav-item">
                <NavLink
                  to="/excel-import"
                  end
                  className={({ isActive }) =>
                    // only highlight as active if we're on the page AND it's within 2–6pm
                    isActive && canCSVimport ? "nav-link active" : "nav-link"
                  }
                  style={{
                    cursor: "pointer",
                    opacity: canCSVimport ? 1 : 0.7, // just visually fade it when off-hours
                  }}
                  onClick={(e) => {
                    if (!canCSVimport) {
                      e.preventDefault();
                      window.alert(
                        "Excel Import is only accessible between 1 PM To 7 PM."
                      );
                    }
                  }}
                >
                  <i className="bi bi-upload me-2"></i> Excel Import{" "}
                </NavLink>
              </li>
            )}

          {/* New Module create Loopi checking on 11 Feb 25 */}
          {user?.Auth === "Supervisor" &&
            ["MONU", "VIRAT (MAMA)", "SONU", "Bhopendra Choubey"].includes(user?.Name) && (
              <li className="nav-item">
                <NavLink
                  to="/loopi-checkingView"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-circle me-2"></i> Loopi Checking{" "}
                  {LoopiCheckingCount > 0 && (
                    <span className="badge bg-danger">
                      {LoopiCheckingCount}
                    </span>
                  )}
                </NavLink>
              </li>
            )}

          {/*loopi checking  this will be only accessed by ANWAR */}
          {(
            (user?.Auth === "Supervisor" && user?.Name === "ANWAR") ||
            user?.Auth === "SuperAdmin"
          ) && (
            <li className="nav-item">
              <NavLink
                to="/loopi-checking"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-circle me-2"></i> Loopi Checking{" "}
                {/* {ticketCount > 0 && (
                <span className="badge bg-danger">{ticketCount}</span>
              )} */}
              </NavLink>
            </li>
          )}

          {/* New Module create  on 15 Apr 25 */}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/Users-Ticket-View"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-chat-left-dots me-2"></i>Ticket View{" "}
                {Delay30minCount > 0 && (
                  <span className="badge bg-danger">{Delay30minCount}</span>
                )}
              </NavLink>
            </li>
          )}

          {/* Worker's Tickets Module */}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/workers-Ticket-View"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-ticket-perforated me-2"></i>Worker's Tickets
              </NavLink>
            </li>
          )}

          {/* New Module create  on 18 Apr 25 */}
          {["2", "9", "1017", "1021", "1022", "9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/Stock-Valuation"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-cash-coin me-2"></i> Stock Valuation{" "}
                {/* {LoopiCheckingCount > 0 && (
                <span className="badge bg-danger">{LoopiCheckingCount}</span>
              )} */}
              </NavLink>
            </li>
          )}

          {/* New Module create  on 19 Apr 25 this module only visible to monu */}
          {["4", "1021","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/RM-Return"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-camera me-2"></i> RM Return{" "}
                {CaptureNotify > 0 && (
                  <span className="badge bg-danger">{CaptureNotify}</span>
                )}
              </NavLink>
            </li>
          )}
          {/* New Module create  on 19 Apr 25 this module only visible to this supervisors */}
          {["7", "3", "5", "6", "1021", "9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/Add-Return-RM"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-arrow-return-left me-2"></i> RM Return{" "}
                {/* {LoopiCheckingCount > 0 && (
                <span className="badge bg-danger">{LoopiCheckingCount}</span>
              )} */}
              </NavLink>
            </li>
          )}
          {/* New Module create  on 21 Apr 25 this module only visible to admins */}
          {["1017", "1016", "9", "1021", "1022", "9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/Verify-Return-RM"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-patch-check me-2"></i>Verify RM Return{" "}
                {Approve > 0 && (
                  <span className="badge bg-danger">{Approve}</span>
                )}
              </NavLink>
            </li>
          )}

          {/* New Module create  on 23 Apr 25 this module only visible to monu */}
          {["4", "1021", "9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/Bill-Upload"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-receipt me-2"></i> Bill Upload{" "}
                {/* {CaptureNotify > 0 && (
                <span className="badge bg-danger">{CaptureNotify}</span>
              )} */}
              </NavLink>
            </li>
          )}
          {/* New Module create  on 23 Apr 25 this module only visible to  */}
          {["1016", "1021", "1022","2918","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/View-Bill"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-receipt me-2"></i> View Bill{" "}
                {/* {CaptureNotify > 0 && (
                <span className="badge bg-danger">{CaptureNotify}</span>
              )} */}
              </NavLink>
            </li>
          )}

          {/* RM isseu Table  */}
          {(user?.Auth === "Supervisor" || user?.Auth === "Admin" || user?.Auth === "SuperAdmin") &&
            !["4", "90", "9696"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/rm-issued-logs"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-card-checklist me-2"></i> RM Issued Logs{" "}
                  {rmIssueCount > 0 && (
                    <span className="badge bg-danger">{rmIssueCount}</span>
                  )}
                </NavLink>
              </li>
            )}

          {/* added on 17 jan 25 */}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <div className="nav-link">
                <i className="bi bi-speedometer2 me-2"></i>Performance:{" "}
                {performance !== null ? (
                  <>
                    <strong
                      style={{
                        color:
                          performance >= 80
                            ? "green"
                            : performance >= 50
                            ? "orange"
                            : "red", // Color conditions
                      }}
                    >
                      {performance}%
                    </strong>{" "}
                    (Score:{score})
                  </>
                ) : (
                  "Loading..."
                )}
              </div>
            </li>
          )}
          {/* end */}
          {/* 29 jan 25 order dispatch module*/}
          {/* {user?.Auth === "SuperAdmin" && user?.Name !== "Sandeep Maintenance"&& ( */}
          {/* {(user?.Auth === "SuperAdmin" && !["33", "34", "35", "36", "9696"].includes(user?.EmployeeID)) && (
          <li className="nav-item">
            <NavLink
              to="/order-dispatch"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <i className="bi bi-calendar-check"></i> Order Dispatch{" "}
          
            </NavLink>
          </li>
        )} */}
          {/* this is backup code  */}
          {/* {((user?.Auth === "SuperAdmin" &&
            !["33", "34", "35", "36"].includes(user?.EmployeeID)) ||
            user?.EmployeeID === "2918") && (
            <li className="nav-item">
              <NavLink
                to="/RM-Upload"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi bi-upload me-2"></i> RM Upload{" "}
              </NavLink>
            </li>
          )} */}

          {/* ── RM Upload (SuperAdmin except 33–36, or ID 2918; only 15:00–10:00 IST) ── */}
          {((user?.Auth === "SuperAdmin" && !["33", "34", "35", "36", "9696"].includes(user?.EmployeeID)) ||
            ["2918", "1022","9"].includes(user?.EmployeeID)) && (
            <li className="nav-item">
              <NavLink
                to="/RM-Upload"
                end
                className={({ isActive }) =>
                  // only highlight as active if we're on the page AND it's within 3–10am
                  isActive && canRMUpload ? "nav-link active" : "nav-link"
                }
                style={{
                  cursor: "pointer",
                  opacity: canRMUpload ? 1 : 0.7, // just visually fade it when off-hours
                }}
                onClick={(e) => {
                  if (!canRMUpload) {
                    e.preventDefault();
                    window.alert(
                      "RM Upload is only accessible between 3 PM To 10 AM."
                    );
                  }
                }}
              >
                <i className="bi bi-upload me-2" /> RM Upload{" "}
              </NavLink>
            </li>
          )}

          {/* New Module create  on 16 Apr 25 */}
          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/Admin-Ticket-View"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-chat-left-dots me-2"></i>Ticket View{" "}
                {Delay60minCount > 0 && (
                  <span className="badge bg-danger">{Delay60minCount}</span>
                )}
              </NavLink>
            </li>
          )}

          {/* Ṇew Module create on 16 Apr 25 this will only visible to swapnil */}
          {user?.Auth === "SuperAdmin" &&
            ["ADM01", "11"].includes(user?.EmployeeID) &&
            !["33", "34", "35", "36"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/SuperAdmin-Ticket-View"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-chat-left-dots me-2"></i>Works Ticket View{" "}
                  {Delay90minCount > 0 && (
                    <span className="badge bg-danger">{Delay90minCount}</span>
                  )}
                </NavLink>
              </li>
            )}
          {/* New Module create  on 23 May 25 this module only visible to Swapnil  */}
          {["11","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/EveryDay-FoamCutting"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-receipt me-2"></i> EveryDay-FoamCutting{" "}
                {/* {CaptureNotify > 0 && (
                <span className="badge bg-danger">{CaptureNotify}</span>
              )} */}
              </NavLink>
            </li>
          )}

          {/* New Module create  on 2 Jun 25 this module only visible to Faisal Sir  */}
          {["10","1021","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/Approval"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-patch-check me-2"></i> Remarks Approval{" "}
                {Approval > 0 && (
                  <span className="badge bg-danger">{Approval}</span>
                )}
              </NavLink>
            </li>
          )}
          {/* this module only visible to ashwini created of 13 Jun 25 */}
          {["1021","1017","9696"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/BOM-Verification"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-folder-check me-2"></i> Tally BOM Upload
                </NavLink>
              </li>
            )}

          {/* this module only visible to sankita created of 19 July 25 */}
          {["1021","1015","9696"].includes(user?.EmployeeID) && (
              <li className="nav-item">
                <NavLink
                  to="/Bom-DataView"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-folder-check me-2"></i> BOM Verification
                </NavLink>
              </li>
            )}

          {["10", "90", "1022", "1021", "1017", "13", "2918", "9","9696"].includes(
            user?.EmployeeID
          ) && (
            <li className="nav-item">
              <NavLink
                to="/Red-Process"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-exclamation-octagon-fill me-2"></i> Red
                Process{" "}
                {RedProcessCount > 0 && (
                  <span className="badge bg-danger">{RedProcessCount}</span>
                )}
              </NavLink>
            </li>
          )}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/Red-Process"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-exclamation-octagon-fill me-2"></i> Red
                Process{" "}
                {RedProcessCount > 0 && (
                  <span className="badge bg-danger">{RedProcessCount}</span>
                )}
              </NavLink>
            </li>
          )}
          {/* New Module create  on 15 Apr 25 */}
          {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/Remark-Supervisor"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-chat-left-dots me-2"></i>Remarks{" "}
                {Delay30minCount > 0 && (
                  <span className="badge bg-danger">{Delay30minCount}</span>
                )}
              </NavLink>
            </li>
          )}

        {(user?.Auth === "Supervisor" || user?.Auth === "SuperAdmin") && (

            <li className="nav-item">
              <NavLink
                to="/Check-Points"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-check2-circle me-2"></i> Check Points{" "}
                {/* {RedProcessCount  > 0 && (
                <span className="badge bg-danger">{RedProcessCount }</span>
              )} */}
              </NavLink>
            </li>
          )}


             {/* New Module create  on 16 Apr 25 */}
          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (

            <li className="nav-item">
              <NavLink
                to="/View-Check-Points"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-ui-checks me-2"></i>View CheckPoints{" "}
                {CheckpointsCount > 0 && (
                  <span className="badge bg-danger">{CheckpointsCount}</span>
                )}
              </NavLink>
            </li>
          )}

          {/* New Module Created on 25 Jun 25 */}
   
           {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/Stock-Reco"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-boxes me-2"></i> Stock Reco{" "}
                {/* {remarks > 0 && (
                  <span className="badge bg-danger">{remarks}</span>
                )} */}
              </NavLink>
            </li>
          )}

            {["1021","10","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/Stock-Reco-Req"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-box-arrow-in-down-right me-2"></i> Stock Reco Req{" "}
                {/* {remarks > 0 && (
                  <span className="badge bg-danger">{remarks}</span>
                )} */}
              </NavLink>
            </li>
          )}

          {/* New Module Created on 2 July 25 */}
           {["1021","10","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/approved-expenses"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-wallet2 me-2"></i> Approved Expenses{" "}
                {/* {remarks > 0 && (
                  <span className="badge bg-danger">{remarks}</span>
                )} */}
              </NavLink>
            </li>
          )}

       {/* New Module Created on 14 July 25 */}
           {/* {["1021","9","9696"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/lot-status"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-bookmark-check me-2"></i> Lot Status{" "}
               
              </NavLink>
            </li>
          )} */}
             {/* New Module Created on 14 July 25 */}
           {/* {["1021","1022","13"].includes(user?.EmployeeID) && (
            <li className="nav-item">
              <NavLink
                to="/update-lot-status"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-bookmark-check me-2"></i> Lot Status{" "}
              </NavLink>
            </li>
          )} */}

          {/* New Module Created on 05-09-25 */}
          {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (
            <li className="nav-item">
              <NavLink
                to="/RR_CheckPoints"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                <i className="bi bi-bootstrap-reboot me-2"></i> Roles & Reseponsiblity{" "}
                {/* {remarks > 0 && (
                  <span className="badge bg-danger">{remarks}</span>
                )} */}
              </NavLink>
            </li>
          )}


            {(user?.Auth === "Supervisor" || ["1021","9696"].includes(user?.EmployeeID)) && (
              <li className="nav-item">
                <NavLink
                  to="/sales-form"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <i className="bi bi-graph-up-arrow me-2"></i> Sales Form
                </NavLink>
              </li>
            )}


            {/* other */}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
